import React, { FC } from 'react';
import { File as LawFile } from '@law-connect/types';
import DocIcon from './doc.svg?react';
import GenericIcon from './generic.svg?react';
import ImageIcon from './image.svg?react';
import PdfIcon from './pdf.svg?react';
import SheetIcon from './sheet.svg?react';
import RTFIcon from './rtf.svg?react';
import PPTIcon from './ppt.svg?react';
import style from './style.module.less';

interface Props {
  file: File | LawFile;
  className?: string;
  noContainer?: boolean;
  containerClassName?: string;
}

export const FileIcon: FC<Props> = (props) => {
  const { file, className, noContainer, containerClassName } = props;
  let matchString = '';
  if ((file as LawFile)?.id) {
    matchString = (file as LawFile)?.mime;
  } else {
    const f = props?.file as File;
    matchString = f?.type;
  }
  let body = null;

  if (matchString?.startsWith('image/')) {
    body = <ImageIcon className={className ?? ''} />;
  } else {
    switch (matchString) {
      case 'application/pdf':
        body = <PdfIcon className={className ?? ''} />;
        break;
      case 'application/msword':
      // eslint-disable-next-line @stylistic/js/max-len, no-fallthrough
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        body = <DocIcon className={className ?? ''} />;
        break;
      case 'application/rtf':
        body = <RTFIcon className={className ?? ''} />;
        break;
      case 'application/vnd.ms-excel':
      // eslint-disable-next-line @stylistic/js/max-len, no-fallthrough
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        body = <SheetIcon className={className ?? ''} />;
        break;
      case 'application/vnd.ms-powerpoint':
      // eslint-disable-next-line @stylistic/js/max-len, no-fallthrough
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        body = <PPTIcon className={className ?? ''} />;
        break;
      default:
        body = <GenericIcon className={className ?? ''} />;
        break;
    }
  }

  return noContainer ? (
    body
  ) : (
    <div className={`${style.fileIconContainer} ${containerClassName ?? ''}`}>
      {body}
    </div>
  );
};
